var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "control-top-container" },
    [
      _c("div", { staticClass: "control-container-outer" }, [
        _c("div", { staticClass: "control-cotainer" }, [
          _c(
            "button",
            {
              staticClass: "control-item camera",
              class: {
                active: _vm.me.cameraStatus === "on",
                inactive: _vm.me.cameraStatus === "off",
                notExist: _vm.me.cameraStatus === undefined,
              },
              on: { click: _vm.onToggleUserDeviceStatus },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    `camstudy.control.camera.${
                      _vm.me.cameraStatus === "on" ? "off" : "on"
                    }`
                  )
                )
              ),
            ]
          ),
          _c(
            "button",
            {
              staticClass: "control-item setting",
              on: { click: _vm.onToggleDeviceSettingModal },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.control.screenSetting")))]
          ),
          _c(
            "button",
            {
              staticClass: "control-item participant",
              attrs: { "data-usercnt": _vm.roomUserCount },
              on: { click: _vm.onToggleParticipantModal },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.control.participants")))]
          ),
          _c(
            "button",
            {
              staticClass: "control-item more",
              class: { alert: _vm.isExistsUnReadChat },
              on: { click: _vm.onMoreControl },
            },
            [_vm._v(_vm._s(_vm.$t("camstudy.control.more")))]
          ),
          _c(
            "button",
            { staticClass: "control-item go-out", on: { click: _vm.exitRoom } },
            [_vm._v(_vm._s(_vm.$t("camstudy.control.exit")))]
          ),
        ]),
      ]),
      _c("ControlMoreModal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isOpenMoreControl,
            expression: "isOpenMoreControl",
          },
        ],
        on: { onCloseMoreModal: _vm.onCloseMoreModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }